import { HazardKind } from '../traits';
import { cannonPhase, CANNON_WARNING_TICKS } from './cannonTiming';
type Params = { param0: number; param1: number; param2: number; armed: number; hp?: number };

/** Shared anticipation timing for visuals and a single sound at the start of each warning. */
export function hazardWarning(kind: number, hz: Params, tick: number): number {
  if (kind === HazardKind.Cannon) {
    const phase = cannonPhase(hz, tick);
    return hz.hp && phase < CANNON_WARNING_TICKS ? (phase + 1) / CANNON_WARNING_TICKS : 0;
  }
  if (kind === HazardKind.Collapsing) return hz.armed ? Math.max(0, Math.min(1, hz.param1 / Math.max(1, hz.param2 || 30) * 2 - 1)) : 0;
  let left = Infinity;
  if (kind === HazardKind.Crusher) {
    const period = Math.max(30, hz.param0 || 150);
    left = period * 0.45 - (tick + hz.param2) % period;
  } else if (kind === HazardKind.Laser) {
    left = (hz.param0 || 90) - (tick + hz.param2) % ((hz.param0 || 90) + (hz.param1 || 90));
  }
  return left >= 0 && left < 30 ? 1 - left / 30 : 0;
}
